import React from 'react';
import { Bot, Palette, Sparkles, TrendingUp, Globe } from 'lucide-react';
import { Card } from './ui/card';

const Services = () => {
  const services = [
    {
      id: 'service-1',
      icon: Bot,
      title: 'AI Chatbot, Web & Mobile Design',
      description: 'We craft intelligent, human-centered digital experiences powered by AI. Our design and development process focuses on scalability, speed, and conversion, ensuring your digital presence performs flawlessly across all devices.',
      keyAreas: [
        'AI-powered chatbot integration',
        'UX/UI design and responsive architecture',
        'Progressive web and mobile applications',
        'User behavior analytics & adaptive interfaces'
      ],
      color: 'ocean'
    },
    {
      id: 'service-2',
      icon: Palette,
      title: 'Logo & Brand Identity Systems',
      description: 'We build data-informed brand identities that communicate purpose and inspire trust. Our team develops comprehensive identity systems—from logo to color psychology—to ensure your brand remains cohesive and recognizable across every channel.',
      keyAreas: [
        'Brand strategy and tone of voice',
        'Logo systems & visual identity design',
        'Typography, color, and iconography frameworks',
        'Brand guideline documentation'
      ],
      color: 'teal'
    },
    {
      id: 'service-3',
      icon: Sparkles,
      title: 'AI Creator Model – Intelligent Content Production',
      description: 'Leverage the power of your own custom AI model trained exclusively for your brand. From visual generation to automated storytelling, our AI Creator system accelerates content workflows while maintaining brand consistency.',
      keyAreas: [
        'Brand-trained AI for visuals, copy, and campaigns',
        'Automated social media content generation',
        'Video and image creation pipelines',
        'API integration with existing CMS or CRM systems'
      ],
      color: 'navy'
    },
    {
      id: 'service-4',
      icon: TrendingUp,
      title: 'E-Commerce Consulting & Conversion Optimization',
      description: 'We help e-commerce brands increase traffic, engagement, and sales through intelligent design and data-driven optimization. Our experts work with major platforms like Shopify, WooCommerce, and custom-built systems, optimizing every step of the digital sales funnel.',
      keyAreas: [
        'Conversion rate & UX performance audits',
        'Customer journey mapping & analytics setup',
        'Marketplace integration (Amazon, Etsy, eBay)',
        'Multi-currency and cross-border scaling strategy'
      ],
      color: 'ocean'
    },
    {
      id: 'service-5',
      icon: Globe,
      title: 'Global Expansion & Business Setup',
      description: 'We empower entrepreneurs and brands to establish, expand, and operate globally through full-service business setup and compliance support. From U.S. company formation to architectural branding and legal structuring—we make your international transition seamless.',
      keyAreas: [
        'LLC / INC formation, EIN & tax registration',
        'Legal and attorney coordination (corporate & IP)',
        'Trademark registration and brand protection',
        'Office/store architectural design & interior branding',
        'End-to-end market entry consulting'
      ],
      color: 'teal'
    }
  ];

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <div className="services-header">
          <span className="section-label">Our Services</span>
          <div className="services-brand-wrapper">
            <h1 className="services-brand-title">MILAMIND.AI</h1>
            <div className="services-brand-line"></div>
          </div>
          <h2 className="section-title">Comprehensive Solutions for Your Business</h2>
          <p className="section-description">
            From AI-powered automation to global expansion support, we provide end-to-end
            services to elevate your e-commerce business.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Card key={index} className={`service-card service-card-${service.color}`}>
                <div className="service-card-header">
                  <div className="service-icon-wrapper">
                    <IconComponent className="service-icon" size={28} />
                  </div>
                  <h3 className="service-title">{service.title}</h3>
                </div>
                
                <div className="service-card-body">
                  <p className="service-description">{service.description}</p>
                  
                  <div className="service-key-areas">
                    <h4 className="key-areas-title">
                      {service.keyAreas.length > 3 ? 'Key Focus Areas:' : 'Deliverables:'}
                    </h4>
                    <ul className="key-areas-list">
                      {service.keyAreas.map((area, areaIndex) => (
                        <li key={areaIndex} className="key-area-item">
                          <span className="key-area-bullet">→</span>
                          {area}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;